// Services principaux — pages SEO money
import {
  Trees, Scissors, Axe, Leaf, Sparkles, Brush, Building2, Mountain, Hammer, Flower2, Wrench,
} from "lucide-react";

export const SERVICES = [
  {
    slug: "paysagiste-caen",
    title: "Paysagiste à Caen",
    h1: "Paysagiste à Caen — Création & aménagement de jardins haut de gamme",
    short: "Création de jardins sur mesure, aménagement paysager et conseil personnalisé dans le Calvados.",
    icon: "Leaf",
    image: "/photos/taille-haie-photinia-red-robin.webp",
    metaTitle: "Paysagiste Caen | Aménagement Jardin – Jardiniers Normands",
    metaDescription: "Paysagiste à Caen ⭐ Création de jardin, aménagement extérieur, plantation, massifs. Devis gratuit dans tout le Calvados. ☎ 07 80 04 43 90",
    keywords: ["paysagiste caen", "aménagement jardin caen", "paysagiste calvados", "création jardin caen"],
    brand: "jardiniers",
  },
  {
    slug: "jardinier-caen",
    title: "Jardinier à Caen",
    h1: "Jardinier à Caen — Entretien jardin & espaces verts toute l'année",
    short: "Entretien régulier de jardins, tonte, débroussaillage, désherbage et soin des massifs.",
    icon: "Flower2",
    image: "/photos/taille-haie-mixte-laurier-persistants.webp",
    metaTitle: "Jardinier Caen | Entretien Jardin – Jardiniers Normands",
    metaDescription: "Jardinier professionnel à Caen ⭐ Entretien jardin, tonte, taille, désherbage. Contrat annuel ou ponctuel. Devis gratuit ☎ 07 80 04 43 90.",
    keywords: ["jardinier caen", "entretien jardin caen", "tonte pelouse caen", "jardinier calvados"],
    brand: "jardiniers",
  },
  {
    slug: "elagage-caen",
    title: "Élagage à Caen",
    h1: "Élagage à Caen — Élagueur grimpeur Calvados",
    short: "Élagage de précision, taille douce, taille raisonnée par grimpeurs expérimentés et assurés.",
    icon: "Scissors",
    image: "https://images.unsplash.com/photo-1762903938137-49b0a145e241?auto=format&fit=crop&w=1600&q=80",
    metaTitle: "Élagage Caen | Élagueur Grimpeur – Pro Élagage 14",
    metaDescription: "Élagueur à Caen ⭐ Élagage, taille raisonnée, sécurisation d'arbres. Grimpeurs assurés. Intervention sous 24 h après devis, Calvados ☎ 07 80 04 43 90.",
    keywords: ["élagage caen", "élagueur caen", "taille arbre caen", "élagueur calvados"],
    brand: "proElagage",
  },
  {
    slug: "abattage-arbre-caen",
    title: "Abattage d'arbre à Caen",
    h1: "Abattage d'arbre à Caen — Intervention sécurisée par professionnels",
    short: "Abattage classique, abattage par démontage en milieu contraint, évacuation complète.",
    icon: "Axe",
    image: "https://images.unsplash.com/photo-1474742509976-ddec6b387356?auto=format&fit=crop&w=1600&q=80",
    metaTitle: "Abattage Arbre Caen | Démontage Sécurisé – Pro Élagage 14",
    metaDescription: "Abattage arbre à Caen ⭐ Démontage, rétention, évacuation. Travail sécurisé par grimpeurs expérimentés. Devis gratuit Calvados ☎ 07 80 04 43 90.",
    keywords: ["abattage arbre caen", "abattage caen", "démontage arbre caen", "abattage calvados"],
    brand: "proElagage",
  },
  {
    slug: "dessouchage-caen",
    title: "Dessouchage à Caen",
    h1: "Dessouchage à Caen — Rognage de souche par professionnels",
    short: "Suppression de souches au rogneuse mécanique, sans dégâts pour votre terrain.",
    icon: "Hammer",
    image: "https://images.unsplash.com/photo-1474742509976-ddec6b387356?auto=format&fit=crop&w=1600&q=80",
    metaTitle: "Dessouchage Caen | Rognage de Souche – Pro Élagage 14",
    metaDescription: "Dessouchage à Caen ⭐ Rognage souche, extraction mécanique. Terrain prêt à replanter. Devis gratuit dans tout le Calvados ☎ 07 80 04 43 90.",
    keywords: ["dessouchage caen", "rognage souche caen", "enlèvement souche caen"],
    brand: "proElagage",
  },
  {
    slug: "taille-haie-caen",
    title: "Taille de haie à Caen",
    h1: "Taille de haie à Caen — Entretien et taille de précision",
    short: "Taille d'entretien, taille de formation, broyage des déchets verts inclus.",
    icon: "Scissors",
    image: "/photos/taille-grande-haie-thuya-echelle.webp",
    metaTitle: "Taille de Haie Caen | Entretien Haies – Jardiniers Normands",
    metaDescription: "Taille de haie à Caen et dans le Calvados : thuya, laurier, photinia, évacuation des déchets comprise. Devis gratuit ☎ 07 80 04 43 90.",
    keywords: ["taille haie caen", "tailleur haie caen", "entretien haie calvados"],
    brand: "jardiniers",
  },
  {
    slug: "tonte-pelouse-caen",
    title: "Tonte de pelouse à Caen",
    h1: "Tonte de pelouse à Caen — Passage régulier ou ponctuel",
    short: "Tonte, finitions des bordures et ramassage : une pelouse nette, au rythme qui vous convient.",
    icon: "Leaf",
    image: "https://images.pexels.com/photos/32500250/pexels-photo-32500250.jpeg?auto=compress&cs=tinysrgb&w=1600",
    metaTitle: "Tonte Pelouse Caen | Passage Régulier – Jardiniers Normands",
    metaDescription: "Tonte de pelouse à Caen et dans le Calvados : passage régulier ou ponctuel, bordures, ramassage inclus. Devis gratuit ☎ 07 80 04 43 90.",
    keywords: ["tonte pelouse caen", "tondre pelouse caen", "tonte gazon calvados", "jardinier tonte caen"],
    brand: "jardiniers",
  },
  {
    slug: "entretien-jardin-caen",
    title: "Entretien jardin à Caen",
    h1: "Entretien de jardin à Caen — Contrat annuel ou prestation ponctuelle",
    short: "Tonte, désherbage, soin des massifs, ramassage de feuilles : un jardin impeccable toute l'année.",
    icon: "Leaf",
    image: "/photos/taille-haie-thuya-hauteur-jardin.webp",
    metaTitle: "Entretien Jardin Caen | Contrat Annuel – Jardiniers Normands",
    metaDescription: "Entretien jardin à Caen ⭐ Contrat annuel, prestations ponctuelles. Devis gratuit, intervention sous 24 h Calvados ☎ 07 80 04 43 90.",
    keywords: ["entretien jardin caen", "contrat entretien jardin", "entretien espaces verts calvados"],
    brand: "jardiniers",
  },
  {
    slug: "entretien-exterieur-caen",
    title: "Entretien extérieur à Caen",
    h1: "Entretien extérieur à Caen — Tous services pour votre extérieur",
    short: "Solution complète : jardin, élagage, taille de haie, abattage — un seul interlocuteur de confiance.",
    icon: "Mountain",
    image: "/photos/taille-haie-echelle-toit-maison.webp",
    metaTitle: "Entretien Extérieur Caen | Jardin, Haies – Les Jardiniers",
    metaDescription: "Entretien extérieur à Caen : tonte, taille de haies, élagage, désherbage, nettoyage de terrasse. Un seul interlocuteur. Devis gratuit ☎ 07 80 04 43 90.",
    keywords: ["entretien extérieur caen", "entretien maison extérieur", "service extérieur calvados"],
    brand: "jardiniers",
  },
];

export const ICONS = { Trees, Scissors, Axe, Leaf, Sparkles, Brush, Building2, Mountain, Hammer, Flower2, Wrench };

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
